<template>
  <v-container
    class="align-content-start"
    fill-height
    fluid
  >
    <v-row>
      <section-header :breadcrumb-items="breadcrumb" />
    </v-row>

    <!-- Tabs with Date Selector -->
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between">
          <v-tabs
            v-model="activeTab"
            active-class="active-tab"
            background-color="transparent"
            height="30"
            hide-slider
            show-arrows
          >
            <v-tab :href="`#${$t('ALM.Tab.Summary.Slug')}`">
              {{ $t('ALM.Tab.Summary.Title') }}
            </v-tab>
            <v-tab :href="`#${$t('ALM.Tab.LoansPortfolio.Slug')}`">
              {{ $t('ALM.Tab.LoansPortfolio.Title') }}
            </v-tab>
            <v-tab :href="`#${$t('ALM.Tab.DepositsPortfolio.Slug')}`">
              {{ $t('ALM.Tab.DepositsPortfolio.Title') }}
            </v-tab>
            <v-tab :href="`#${$t('ALM.Tab.InvestmentsPortfolio.Slug')}`">
              {{ $t('ALM.Tab.InvestmentsPortfolio.Title') }}
            </v-tab>
          </v-tabs>

          <portfolio-date-selector
            :api-response="almData"
            @date-change="onDateChange"
          />
        </div>
      </v-col>
    </v-row>

    <!-- Tabs Content -->
    <v-row ref="alm">
      <v-col cols="12">
        <v-tabs-items
          v-model="activeTab"
          class="fill-height"
        >
          <!-- Summary Tab -->
          <v-tab-item :value="$t('ALM.Tab.Summary.Slug')">
            <v-row>
              <v-col cols="12">
                <v-lazy
                  :options="{threshold: .5}"
                  transition="fade-transition"
                >
                  <alm-summary
                    :breakpoint="breakpoint"
                    :selected-date="almData.selectedDate"
                  />
                </v-lazy>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Loans Portfolio Tab -->
          <v-tab-item :value="$t('ALM.Tab.LoansPortfolio.Slug')">
            <v-row>
              <v-col cols="12">
                <v-lazy
                  :options="{threshold: .5}"
                  transition="fade-transition"
                >
                  <loans-portfolio :selected-date="almData.selectedDate" />
                </v-lazy>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Deposits Portfolio Tab -->
          <v-tab-item :value="$t('ALM.Tab.DepositsPortfolio.Slug')">
            <v-row>
              <v-col cols="12">
                <v-lazy
                  :options="{threshold: .5}"
                  transition="fade-transition"
                >
                  <deposits-portfolio :selected-date="almData.selectedDate" />
                </v-lazy>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- Investments Portfolio Tab -->
          <v-tab-item :value="$t('ALM.Tab.InvestmentsPortfolio.Slug')">
            <v-row>
              <v-col cols="12">
                <v-lazy
                  :options="{threshold: .5}"
                  transition="fade-transition"
                >
                  <investments-portfolio :selected-date="almData.selectedDate" />
                </v-lazy>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AlmSummary from '@/theme/default/views/banking/alm/summary/AlmSummary.vue'
import LoansPortfolio from '@/theme/default/views/banking/alm/loans/LoansPortfolio.vue'
import DepositsPortfolio from '@/theme/default/views/banking/alm/deposits/DepositsPortfolio.vue'
import InvestmentsPortfolio from '@/theme/default/views/banking/alm/investments/InvestmentsPortfolio.vue'
import PortfolioDateSelector from '@/theme/default/components/form/PortfolioDateSelector.vue'
import i18nRouteMeta                     from '@/mixins/i18n/i18nRouteMeta'
import routerTabState                    from '@/mixins/routerTabState'
import SectionHeader                     from '@/theme/default/components/common/SectionHeader'
import API                               from '@/api/Api'

export default {
  name      : 'ALM',
  components: {
    SectionHeader,
    AlmSummary,
    LoansPortfolio,
    DepositsPortfolio,
    InvestmentsPortfolio,
    PortfolioDateSelector
  },
  mixins   : [i18nRouteMeta, routerTabState],
  dataStore: {
    appToolbarExtended: 'App.Config.AppToolbarExtended'
  },
  data () {
    return {
      breakpoint    : (this.appToolbarExtended && this.$vuetify.breakpoint.smAndDown ? 12 : 6),
      minBlockHeight: 364,
      almData       : {
        selectedDate  : '',
        availableDates: []
      }
    }
  },
  computed: {
    breadcrumb () {
      return [{
        text    : this.$t('ALM.HeaderTitle'),
        disabled: true
      }]
    },
    accountId () {
      return this.user?.selectedAccountId || null
    }
  },
  watch: {
    activeTab: {
      immediate: true,
      handler (newTab) {
        if (!newTab) {
          this.activeTab = this.$t('ALM.Tab.Summary.Slug')
        }
      }
    },
    appToolbarExtended (val) {
      this.breakpoint = val && this.$vuetify.breakpoint.smAndDown ? 12 : 6
    },

    '$vuetify.breakpoint.smAndDown': {
      handler (val) {
        this.breakpoint = val && this.appToolbarExtended ? 12 : 6
      }
    }
  },
  created () {
    this.fetchAvailableDates()
  },
  methods: {
    fetchAvailableDates () {
      API.Resource.ALM.GetAvailableDates(this.accountId)
        .then(response => {
          this.handleResponse(response)
        })
        .catch(e => {
          this.handleResponse(e.response)
        })
        .finally(() => {})
    },
    handleResponse (response) {
      const data = API.responseData(response)?.findALMInfo || null

      const errors = API.responseErrors(response) || []

      if (API.isResponseSuccess(response) && data) {
        this.almData.availableDates = data.availableDates
        this.almData.selectedDate = data.selectedDate
      } else {
        this.$bus.$emit('app:error', errors)
      }
    },
    onDateChange (date) {
      this.almData.selectedDate = date
    }
  }

}
</script>

<style scoped>
</style>
